<div 
    class="button-container" 
    (click)="changeTheSelected()"
    >  
    <div 
        [ngClass]="{
            'highlight': isHighlighted(),
            'detail-trajet': true,
            'trajet': true
        }">
      <div
        class="titles"
        width="8%"
        data-toggle="tooltip"
        (click)="editingControl($event, true)"
        >
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 122.88" style="width: 22.5px;">
            <defs>
                <style>.cls-1,.cls-3{fill:#fff;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#d92d27;}</style>
            </defs>
            <title>stop-road-sign</title>
            <polygon class="cls-1" points="100.64 22.24 84.39 5.99 38.47 6 5.99 38.49 6 84.41 38.49 116.89 84.41 116.88 116.89 84.39 116.88 38.47 100.64 22.24 100.64 22.24"/><path class="cls-2" d="M82,11.82,96.52,26.35l14.53,14.53V82L96.53,96.52,82,111.05H40.9L26.36,96.53,11.83,82V40.9L26.35,26.36,40.88,11.83H82Zm5.77-11L122,35.1a3,3,0,0,1,.88,2.26V85.64a3,3,0,0,1-.87,2.11L87.78,122a3,3,0,0,1-2.26.88H37.24a3,3,0,0,1-2.11-.87L.89,87.78A3,3,0,0,1,0,85.52V37.24a3,3,0,0,1,.87-2.11L35.1.89A3,3,0,0,1,37.36,0H85.64a3,3,0,0,1,2.11.87Zm12.89,21.37L84.39,6H38.47L6,38.49V84.41l32.49,32.48H84.41l32.48-32.49V38.47L100.64,22.24Z"/><path class="cls-3" d="M31.38,73c-.68,0-1.33,0-2-.06s-1.28-.1-1.9-.18-1.22-.17-1.79-.27-1.12-.23-1.65-.37V67.4q1,.09,2.25.15l2.44.1,2.31,0a7.84,7.84,0,0,0,1.68-.16,2,2,0,0,0,1-.49,1.21,1.21,0,0,0,.34-.91v-.37a1.16,1.16,0,0,0-.48-1,1.87,1.87,0,0,0-1.11-.34H30.89a8.09,8.09,0,0,1-5.38-1.55c-1.22-1-1.84-2.79-1.84-5.23v-1a6.17,6.17,0,0,1,2-5,8.92,8.92,0,0,1,5.81-1.66,25.45,25.45,0,0,1,2.7.13c.85.1,1.65.21,2.39.34s1.41.27,2,.41v4.71c-.94-.08-2-.15-3.16-.2s-2.24-.07-3.2-.07a8.8,8.8,0,0,0-1.53.12,1.85,1.85,0,0,0-1,.49,1.42,1.42,0,0,0-.37,1.07v.3a1.39,1.39,0,0,0,.49,1.16,2.3,2.3,0,0,0,1.5.4h2a7.08,7.08,0,0,1,3.56.81A5.21,5.21,0,0,1,39,61.79,6.79,6.79,0,0,1,39.72,65v1a8,8,0,0,1-1,4.44,5,5,0,0,1-2.87,2.06,16.18,16.18,0,0,1-4.46.53ZM47,72.81V55.42H41.31V50.1H58.67v5.32H53V72.81Zm22.8.18a16.67,16.67,0,0,1-4.23-.47,6.47,6.47,0,0,1-3-1.7,7.6,7.6,0,0,1-1.84-3.5,23.14,23.14,0,0,1-.61-5.88,23.14,23.14,0,0,1,.61-5.88,7.6,7.6,0,0,1,1.84-3.5,6.47,6.47,0,0,1,3-1.7,19.27,19.27,0,0,1,8.46,0,6.55,6.55,0,0,1,3,1.7,7.68,7.68,0,0,1,1.83,3.5,23.14,23.14,0,0,1,.61,5.88,23.14,23.14,0,0,1-.61,5.88,7.68,7.68,0,0,1-1.83,3.5,6.55,6.55,0,0,1-3,1.7,16.67,16.67,0,0,1-4.23.47Zm0-5.31a5.6,5.6,0,0,0,1.9-.28,2.21,2.21,0,0,0,1.14-1,4.85,4.85,0,0,0,.58-1.89,24.09,24.09,0,0,0,.17-3.12,24.85,24.85,0,0,0-.17-3.21,4.74,4.74,0,0,0-.58-1.88,2.08,2.08,0,0,0-1.14-.9,7.27,7.27,0,0,0-3.78,0,2.05,2.05,0,0,0-1.16.9,4.74,4.74,0,0,0-.58,1.88A24.85,24.85,0,0,0,66,61.44a24.09,24.09,0,0,0,.17,3.12,4.85,4.85,0,0,0,.58,1.89,2.18,2.18,0,0,0,1.16,1,5.6,5.6,0,0,0,1.88.28Zm12.5,5.13V50.1h10a11.63,11.63,0,0,1,2.38.26,5.38,5.38,0,0,1,2.25,1.07,5.59,5.59,0,0,1,1.65,2.44,12.48,12.48,0,0,1,.62,4.36,13.09,13.09,0,0,1-.61,4.42A5.75,5.75,0,0,1,97,65.15a5.3,5.3,0,0,1-2.12,1.14,9.24,9.24,0,0,1-2.25.28c-.38,0-.79,0-1.2-.06s-.83-.09-1.23-.16l-1.1-.22L88.26,66v6.85Zm5.93-11.55h3.43a1.37,1.37,0,0,0,1-.34,1.85,1.85,0,0,0,.49-1,8.35,8.35,0,0,0,.14-1.64,6.5,6.5,0,0,0-.17-1.59,1.91,1.91,0,0,0-.51-1,1.23,1.23,0,0,0-.91-.32H88.26v5.84Z"/>
        </svg>
      </div>
      <div style="overflow: hidden; width: 120%;" [@.disabled]="!isAnimated">
          <div 
            class="information-section" 
            *ngIf="!isInEditMode()"
            @slideOutIn>
            <div class="item-informations">
                <div class="general-infos">
                    <span class="resume-adress">{{filredAdress | slice:0:20}} <span *ngIf="filredAdress.length>20">...</span>  </span>
                    <span class="timing">{{childDetail.beginStopTime| date :'MM/dd/yyyy HH:mm'}}</span>
                    <span class="location"> {{ childDetail.stopLatitude | number : "1.0-6" }} , {{ childDetail.stopLongitude | number : "1.0-6" }}</span>
                </div>
                <span 
                  class="adress"
                  width="8%"
                  data-toggle="tooltip"
                  title="{{ childDetail.adress && childDetail.adress.display_name ? childDetail.adress.display_name: '' }}" 
                > 
                    {{ childDetail.adress.display_name | slice:0:80 }} <span *ngIf="childDetail.adress && childDetail.adress.display_name && childDetail.adress.display_name.length > 80">...</span>
                </span>
              </div>
              <div class="duration">
                <span style="color: #555;">{{childDetail.stopDuration || 00 | formatFullDuration}}</span>
              </div>
          </div>
    
        <div 
            style="width: 100%;"  
            *ngIf="isInEditMode()"  
            @slideInOut>
            <app-add-stop-poi
              [childStop]="childDetail"
              (closeEditing)="closeEditing()"
            ></app-add-stop-poi>
        </div> 
      </div>
    </div>
</div>
